// extracted by mini-css-extract-plugin
export default {"error":"EditQrTagBatch_error__5DMHe","successToast":"EditQrTagBatch_successToast__X8nVT","slideInRight":"EditQrTagBatch_slideInRight__Wk-Tr"};